module.exports = __webpack_public_path__ + "static/media/logo.2b3404c4.svg";